<template>
  <v-dialog
      v-model="dialog"
      max-width="80%"
      transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
          dark
          dense
          color="primary"
          elevation="0"
          tile
          class="domains-budget-toolbar"
      >
        <v-btn
            icon
            dark
            @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Domains Budget Upload</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <div class="domains-budget">
        <v-subheader>Upload domains budget from CSV file.</v-subheader>

        <v-container
            class="px-0"
            fluid
        >
          <v-row>
            <v-col cols="4">
              <v-file-input
                  accept=".csv"
                  label="Click here to select a .csv file"
                  outlined
                  v-model="chosenFile"
                  class="domains-budget-input"
              >
              </v-file-input>
            </v-col>
            <v-col cols="8">
              <v-btn
                  elevation="0"
                  color="primary"
                  x-large
                  @click="importCsv">
                <i class="fal fa-file-import mr-2"></i>
                Import file
              </v-btn>
            </v-col>
          </v-row>

          <label v-if="isCsvLoaded">Selected CSV file: {{ chosenFile.name }}</label>
        </v-container>

        <v-row >
          <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="fileContent"
                class="elevation-1 domains-budget-table"
            >
            </v-data-table>
          </v-col>
        </v-row>

        <v-btn
            elevation="0"
            color="primary"
            @click="processDomainsBudget()"
            style="margin-right: 10px"
        >
          Process Domains Budget
        </v-btn>
        <p v-if="resultText" class="result-text" v-html="resultText.replace(/(Domain:|Total:)/g, '<br>$1')"></p>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import csvParse from 'csv-parse';
import domainVertical from "../../../api/domains";

export default {
  name: 'DomainsBudgetImport',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'open',
    event: 'toggle',
  },
  data() {
    return {
      resultText:'',
      dialog: false,
      chosenFile: null,
      fileContent: [],
      headers: [
        { text: 'Domain', value: 'domain' },
        { text: 'Budget', value: 'budget' },
        { text: 'Country to block', value: 'countriesToBlock' },
        { text: 'Country to unblock', value: 'countriesToUnBlock' },
      ],
      isCsvLoaded: false,
    };
  },
  watch: {
    dialog() {
      this.$emit('toggle', this.dialog);
    },
    open() {
      this.dialog = this.open;
    },
  },
  async mounted() {
    this.dialog = this.open;
  },
  methods: {
    async importCsv() {
      try {
        if (!this.chosenFile) {
          await this.$dialog.info({
            text: `No file selected`,
            title: 'Validation Error'
          });
          return;
        }

        const readFile = await this.processFile(this.chosenFile);
        const data = await this.formatData(readFile);

        this.fileContent = data;
        this.resultText = '';
        this.isCsvLoaded = true;
      } catch (e) {
        console.error('importCsvError', e);
        await this.$dialog.error({
          text: `Error importing CSV file: ${e}`,
          title: 'Import Error'
        });
      }
    },
    async processFile(file) {
      const reader = new FileReader();
      reader.readAsText(file);
      return new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = () => {
          reject(reader.error);
        };
      });
    },
    async formatData(dataFile) {
      return new Promise((resolve, reject) => csvParse(
          dataFile,
          {
            columns: true,
            skip_empty_lines: true
          },
          (err, output) => {
            if (err) {
              reject(err);
            } else {
              const formattedData = output.map(record => ({
                domain: record['Domain'] ? record['Domain'].trim(): '',
                budget: record['Budget'] ? record['Budget'].trim(): 0,
                countriesToBlock: record['Countries to block (optional)'] ? record['Countries to block (optional)'].trim() : '',
                countriesToUnBlock: record['Countries to unblock (optional)'] ? record['Countries to unblock (optional)'].trim() : '',
              }));
              resolve(formattedData);
            }
          }
      ));
    },
    async processDomainsBudget() {
      console.log('Processing Domains Budget:', JSON.stringify(this.fileContent));
      const res = await domainVertical.domainBudgetImport(this.fileContent)
      console.log('res', res);
      if (res.success){
        await this.$dialog.notify.success(`Domains budget imported successfully`, {
          position: 'top-right',
          timeout: 1000
        })

        this.resultText = res.message;
      } else {
        await this.$dialog.notify.error(`Error importing domains budget: ${res.message}`, {
          position: 'top-right',
          timeout: 2000
        })
      }
    },
  },
};
</script>
<<style scoped>
.result-text {
  color: #4CAF50;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.domains-budget-toolbar {
  background-color: #1976D2;
}

.domains-budget-input {
  border-color: #1976D2;
}

.v-dialog {
  min-height: 80vh;
  overflow-y: auto;
}

.v-data-table .v-data-table__wrapper {
  overflow-x: hidden;
  width: 100%;
}

.domains-budget {
  padding: 20px;
}


</style>